<div class="form-group {{ formGroupClass }}">
	<label class="control-label {{ labelClass }}" for="{{ id }}">{{ label }} :</label>
	<div class="{{ fieldClass }}">
		<div *ngFor="let textInput of textInputs; let i = index" class="input-group" >
			<input type="text" name="{{ id + i }}" id="{{ id + i }}"
				[ngClass]="textInput.isValid ? 'form-control': 'error form-control'"
				[ngModel]="textInputs[i].value" 
				(focusout)="onFocusOut($event, i)" 
				[placeholder]="placeholder + ' ' + (i + 1)" />
			<div class="input-group-addon">
				<a class="" href="#" title="Retirer" (click)="removeInput(i)" [ngClass]="{'disabled': i == 0}">
					<span class="fa fa-minus-circle fa-lg"></span>
				</a>
			</div>
			<div class="input-group-addon">
				<a class="" href="#" title="Ajouter" (click)="addInput()" [ngClass]="{'disabled': 0 < i && i < textInputs.length - 1}">
					<span class="fa fa-plus-circle fa-lg"></span>
				</a>
			</div>
		</div>
	</div>
</div>
